import styled from 'styled-components'
import { CardElement, ImgComponent } from 'Pages/landings/newLandings/common/components'
import {
	Breakpoints,
	themeObject,
	textModels,
	WrapperBlock,
	mediaOnly,
} from 'Pages/landings/newLandings/common/style'

export const Wrapper = styled(WrapperBlock)``
export const Title = styled.p`
	${textModels('heading', 'h2')};
	color: ${themeObject.colors.grey[800]};
	margin-bottom: 8px;
	text-align: center;
`
export const SubTitle = styled.div`
	${textModels('notAdaptive', 'xl', '400')};
	color: ${themeObject.colors.grey[600]};
	text-align: center;
	margin-bottom: 48px;
`
export const List = styled.ul`
	display: grid;
	grid-template-columns: repeat(3, 1fr);
	gap: 32px;
	${mediaOnly('grid-template-columns: repeat(2, 1fr);', Breakpoints.ms, Breakpoints.lx)}
	${mediaOnly('grid-template-columns: 1fr;', '0', '767px')}
`

export const Img = styled(ImgComponent)`
	width: 64px;
	height: 64px;
	border-radius: 16px;
	padding: 12px;
	margin-bottom: 24px;
	box-sizing: border-box;
	background-color: #5e94d7;
`
export const ImgPng = styled.img`
	width: 40px;
	height: 40px;
`

export const SubWrapper = styled.div`
	display: grid;
	grid-template-columns: repeat(2, 384px);
	justify-content: center;
	width: 100%;
	grid-column: span 3;
	gap: 32px;
`

export const CardElementStyled = styled(CardElement)`
	&:nth-child(5) {
		${mediaOnly(
			'grid-column: span 2; width: 424px; justify-self: center;',
			Breakpoints.ms,
			Breakpoints.lx
		)}
	}
`
